import { Toast as ToastPrimitive } from "@base-ui/react/toast";

export const toastManager = ToastPrimitive.createToastManager();
